import { useQuery } from '@tanstack/react-query';
import { receiptsService } from '@/services/receiptsService';
import type { ReceiptFilters } from '@/types/receipt';

export function useReceipts(filters: ReceiptFilters = {}) {
  return useQuery({
    queryKey: ['receipts', filters],
    queryFn: () => receiptsService.getReceipts(filters),
    staleTime: 1000 * 60 * 2, // 2 minutes
  });
}

export function useReceipt(id: string | null) {
  return useQuery({
    queryKey: ['receipts', id],
    queryFn: () => receiptsService.getReceipt(id!),
    enabled: !!id,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}

export default {
  useReceipts,
  useReceipt,
};
